import { selectPpid } from '../../../selectors/config';
import {
  selectCanShowPersonalizedAdsUnderGdpr,
  selectGdprApplies,
  selectIsOptedOut,
} from '../../../selectors/app';

export default function getPpid(state) {
  const canShowPersonalizedAds = selectGdprApplies(state)
    ? selectCanShowPersonalizedAdsUnderGdpr(state)
    : !selectIsOptedOut(state);
  return canShowPersonalizedAds ? selectPpid(state) : undefined;
}
